import { memo } from 'react';
import { useTranslation } from '@aimsos/i18n';
import { Button } from '@aimsos/ui';
import { Plus } from 'lucide-react';

import PhoneRow from './PhoneRow.jsx';

/** The phone numbers of a customer; exactly one of them is the primary. */
function PhoneList({ phones, errors = {}, onChange, onMakePrimary, onRemove, onAdd }) {
  const { t } = useTranslation('unified-profiles');

  return (
    <fieldset className="flex flex-col gap-3">
      <legend className="mb-1 p-0 text-sm font-medium text-content-secondary">
        {t('create.fields.phones.legend')}{' '}
        <span className="font-normal text-content-muted">{t('create.fields.phones.optional')}</span>
      </legend>
      <p className="text-xs text-content-muted">{t('create.fields.phones.helper')}</p>
      {phones.map((phone, index) => (
        <PhoneRow
          key={phone.id}
          phone={phone}
          index={index}
          placeholder={
            index === 0 ? t('create.fields.phones.placeholder') : t('create.fields.phones.placeholderOther')
          }
          error={errors[phone.id]}
          onChange={onChange}
          onMakePrimary={onMakePrimary}
          onRemove={onRemove}
        />
      ))}
      <div className="flex items-center justify-between gap-3">
        <Button variant="tertiary" size="sm" leftIcon={Plus} onClick={onAdd}>
          {t('create.fields.phones.add')}
        </Button>
        {/* Only worth saying once there is a choice to make. */}
        {phones.length > 1 ? (
          <span className="text-xs text-content-muted">{t('create.fields.phones.pickPrimary')}</span>
        ) : null}
      </div>
    </fieldset>
  );
}

export default memo(PhoneList);
